module.exports = __webpack_public_path__ + "static/media/instagram-theme-icon.c268db11.svg";